import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal as BootstrapModal } from 'react-bootstrap';
import DonutChart from 'react-donut-chart';
import PieDesign from './DashboardPages/PieDesign'; // Ensure correct path
import PieRetail from './DashboardPages/PieRetail';
import PieSites from './DashboardPages/PieSites';

const PieChart = () => {
    const [modalState, setModalState] = useState({ Design: false, Retail: false, Site: false });
    const [chartData, setChartData] = useState([]);

    const handleSliceClick = (e) => {
        const label = e.dataPoint.label;
        if (['Retail', 'Site', 'Design'].includes(label)) {
            setModalContent({
                label: label,
                value: e.dataPoint.y
            });
            setModalState(prevState => ({ ...prevState, [label]: true }));
        }
    };

    const [modalContent, setModalContent] = useState(null);

    const getColor = (type) => {
        switch (type) {
            case 'Design': return '#FF6384';
            case 'Retail': return '#36A2EB';
            case 'Site': return '#FFCE56';
            default: return '#CCCCCC'; 
        }
    };

    const fetchData = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                console.error("Token not found in localStorage");
                return;
            }
    
            if (!process.env.REACT_APP_API_URL) {
                console.error("API URL is not defined in environment variables");
                return;
            }
    
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Dashbord-Customer-due-payment-lise`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token
                }
            });
    
            const data = response.data.data || [];
            console.log("Fetched data:", data); // Debug the API response
    
            const dataPoints = data.map(item => ({
                y: item.total_amount,
                label: item.customer_type,
                color: getColor(item.customer_type),
                indexLabelFontColor: "#000"
            }));
    
            console.log("Formatted dataPoints:", dataPoints); // Check data format for the chart
    
            setChartData(dataPoints);
        } catch (error) {
            console.error('Error fetching data:', error.message, error.response?.data);
        }
    };
    

    useEffect(() => {
        const testChartData = [
            { label: "Design", value: 40, color: "#FF6384" },
            { label: "Retail", value: 30, color: "#36A2EB" },
            { label: "Site", value: 30, color: "#FFCE56" }
        ];
        setChartData(testChartData);
    }, []);


    useEffect(() => {
        fetchData();
    }, []);

    const closeModal = () => {
        setModalState({ Design: false, Retail: false, Site: false });
        setModalContent(null);
    };

    return (
        <div className='position-relative donut-chart-container'>
            <DonutChart
                data={chartData.map(item => ({
                    label: item.label,
                    value: item.value || item.y,
                    color: item.color
                }))}
                legend={false}
                onClick={(data) => handleSliceClick({ dataPoint: data })}
                height={300}
                width={300}
                innerRadius={0.5}
            />

            <div className="legend">
                {chartData.map(item => (
                    <div key={item.label} className="legend-item">
                        <span style={{ backgroundColor: item.color }} className="legend-color" />
                        <span className="legend-text">{item.label}</span>
                    </div>
                ))}
            </div>

            {modalContent && (
                <BootstrapModal
                    show={modalState[modalContent.label]}
                    onHide={closeModal}
                    size='lg'
                    aria-labelledby="modal-title"
                    backdrop="static"
                    keyboard={false}
                >
                    <BootstrapModal.Header closeButton>
                        <BootstrapModal.Title id="modal-title">{modalContent.label} Details</BootstrapModal.Title>
                    </BootstrapModal.Header>
                    <BootstrapModal.Body>
                        {/* Conditionally render the relevant modal based on content.label */}
                        {modalContent.label === 'Design' && <PieDesign content={modalContent} closeModal={closeModal} />}
                        {modalContent.label === 'Retail' && <PieRetail content={modalContent} closeModal={closeModal} />}
                        {modalContent.label === 'Site' && <PieSites content={modalContent} closeModal={closeModal} />}
                    </BootstrapModal.Body>
                </BootstrapModal>
            )}
        </div>
    );
};

export default PieChart;
